import { Dispatch, ReactNode, useId } from 'react';
import { FormSelect, FormSelectOption } from '../../../components/form/FormSelect';
import { TransactionsDateFilterDialogFromGroup } from './TransactionsDateFilterDialogFromGroup';
import { TransactionsDateFilterDialogLabel } from './TransactionsDateFilterDialogLabel';

export function TransactionsDateFilterDialogSelect<T>({
  label,
  options,
  value,
  onValueChange,
}: {
  label: ReactNode;
  options: FormSelectOption<T>[];
  value: T;
  onValueChange?: Dispatch<T>;
}) {
  const controlId = useId();

  return (
    <TransactionsDateFilterDialogFromGroup>
      <TransactionsDateFilterDialogLabel htmlFor={controlId}>{label}</TransactionsDateFilterDialogLabel>

      <FormSelect
        className="form-select form-select-sm"
        id={controlId}
        options={options}
        value={value}
        onValueChange={onValueChange}
      />
    </TransactionsDateFilterDialogFromGroup>
  );
}
